<template>
  <main class="unsubscribe">
    <app-loading v-if="isLoading"></app-loading>
    <div v-else>
      <p class="unsubscribe-message">
        メール配信を<br class="sp-on">停止しました。
      </p>
    </div>
  </main>
</template>

<script>
  import Loading from '../common/Loading.vue';
  export default {
    title: 'メール配信を停止 | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'メール配信を停止',
    description: 'abceed のメール配信を停止はこちら',
    keywords: 'toeic,abceed,globee,メール配信を停止',
    headerType: 'unsubscribe',
    components: {
      appLoading: Loading
    },
    data() {
      return {
        isLoading: false
      }
    },
    created() {
      this.unSubscribe();
    },
    methods: {
      unSubscribe() {
        this.$store.dispatch("showLightBox", "loading");
        let token = "";
        if (this.$route.query.token) {
          token = this.$route.query.token
        }
        this.$store.dispatch('unsubscribe', {token:token})
          .then(data => {
            if (data.message) {
              //通信に失敗
              alert("通信に失敗しました。");
              this.$router.push({name: 'rankingHome'});
              this.$store.dispatch("hideLightBox");
              return false;
            }
            this.$store.dispatch("changeLoadingCondition", false);
            //ログイン成功の場合はログイン処理を行う
            this.$store.dispatch("setLogin", data);
            this.$store.dispatch("hideLightBox");
          });
      }
    }
  }
</script>

<style scoped lang="scss">
  .unsubscribe {
    background-color: #FF5B60;
    margin-bottom: -32px;
    min-height: calc(100vh - 281px);
    display: flex;
    align-items: center;
    justify-content: center;
    .unsubscribe-message {
      font-size: 24px;
      font-weight: bold;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/Unsubscribe.vue